const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/assistant/{-$conversationId}.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/assistant/{-$conversationId}.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { loadAssistantRoute, resolveAssistantConversationId } from '@/app/lib/assistant-load';
import { AssistantSkeleton } from '@/features/assistant/ui/assistant-skeleton';
export const Route = createFileRoute('/_authenticated/assistant/{-$conversationId}')({
  beforeLoad: ({
    context,
    params
  }) => {
    const conversationId = resolveAssistantConversationId(params.conversationId, context.deps.validators.conversationIdValidator);
    return {
      conversationId
    };
  },
  loader: async ({
    context,
    location
  }) => {
    await loadAssistantRoute({
      queryClient: context.queryClient,
      controllers: {
        assistantController: context.deps.controllers.assistantController
      }
    }, {
      conversationId: context.conversationId,
      next: `${location.pathname}${location.searchStr}`
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: AssistantSkeleton
});